// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"ede965da","205":"8f6d0e0d","276":"5f6245f4","332":"92f9b184","422":"72925f90","453":"b9e64f82","545":"cdab2498","796":"ea78901d","843":"bb4a1382"}[chunkId] + ".chunk.js";
};